export default function currencyToSymbol(currency) {
  if (currency === 'GBP') {
    return '£';
  }
  return '$';
}



// WEBPACK FOOTER //
// ./library/app/utils/currencyToSymbol.js